const ActionNotificationGrowlComponent = {
    templateUrl: '/ui/notification/notificationGrowl/notificationGrowl.tpl.html',
    controller: 'notificationGrowlController',
    bindings: {
        notification: '<',
        isLoadingBar: '<',
        closeNotification: '&',
        startTimer: '&',
        clearTimer: '&'
    }
};

angular.module('umCore')
    .component('actionNotificationGrowl', ActionNotificationGrowlComponent);
